module.exports = __webpack_public_path__ + "static/media/sos.676f1f78.png";